<template>
  <CCard>

    <CCardBody>
      <BTabs>
        <BTab :title="$t('organizationDesign')" v-if="get_access('company_chart')">
          <PositionChart/>
        </BTab>
        <BTab :title="$t('JobDefinition')">
          <JobPositions/>
        </BTab>
        <BTab v-if="get_access('job_unit')" :title="$t('companyChart')">
          <ChartPositions/>
        </BTab>
        <BTab v-if="get_access('cost_centers')" :title="$t('costCenter')">

          <CCardBody>
            <CostCenterLists/>
          </CCardBody>

        </BTab>

        <BTab v-if="get_access('branch')" :title="$t('Branch')">
          <Branches/>
        </BTab>
        <BTab v-if="get_access('request_confirm')" :title="$t('requestConfirmer')">
          <ModirAcceptRequest/>
        </BTab>




      </BTabs>

    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import PositionChart from "./PositionChart";
import JobPositions from "./JobPositions";
import CostCenterLists from "./CostCenterLists";
import Branches from "../base/Branches";
import ChartPositions from "./ChartPositions";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ModirAcceptRequest from "../settings/ModirAcceptRequest";
import BTabs from "../../tabs/BTabs";
import BTab from "../../tabs/BTab";

export default {
  name: 'Login',
  components: {
    BTab,
    BTabs,
    PositionChart,
    JobPositions,
    CostCenterLists,
    Branches,
    ModirAcceptRequest,
    ChartPositions
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {
    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML



  }, watch: {
  },
  methods: {

  }
}

</script>
